var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueTimepicker',{attrs:{"format":"HH:mm","minute-interval":5,"value":_vm.time},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }